import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";
import { Store } from "@ngrx/store";

import { AppState } from "../../app/app.reducer";
import { User } from "../../app/app.models";
import { UserdetailPage } from "../userdetail/userdetail";
import { UsersFetchAction } from "../../app/app.actions";
import { ConfigService } from "../../services/config.service";
import * as firebase from "firebase";
import { AppUtilities } from "../../app/app.utilities";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "page-ranking",
  templateUrl: "ranking.html"
})
export class RankingPage {
  public search$: string = "";
  public user$: User;
  public users$: any[] = [];
  public userdetailPage = UserdetailPage;
  public titles$: String[] = [];
  public groups$: Array<any[]> = [];
  numFans: number;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public store: Store<AppState>,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    private utils: AppUtilities,
    private translate: TranslateService,
    private authService: AuthService
  ) {
    this.user$ = this.authService.getUser();

    this.getFansFirebase();
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad RankingPage");
  }

  ionViewWillEnter() {}

  ngOnInit() {
    if (!this.users$.length) this.store.dispatch(new UsersFetchAction());
  }

  sortFans() {
    this.numFans = this.users$.length;
    if (this.users$ && typeof this.users$.sort === "function") {
      // Sort all idols alphabetically
      this.users$.forEach((user: any) => {
        user.name = user.name.charAt(0).toUpperCase() + user.name.slice(1);
        console.log("User Upercase " + user.name);
      });

      this.groups$ = [];
      this.titles$ = [];

      this.users$.sort((a: any, b: any) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;

        return 0;
      });

      // Group idols by first character
      this.users$.forEach((user: any) => {
        let charAt = user.name.charAt(0);
        let indexOf = this.titles$.indexOf(charAt);

        if (indexOf === -1) {
          // Add character to titles
          this.titles$.push(charAt);
          // Update indexOf new title
          indexOf = this.titles$.indexOf(charAt);
          // Create new group with same indexOf
          this.groups$[indexOf] = [];
        }
        this.groups$[indexOf].push(user);
      });
    }
  }

  getItems(ev: any) {
    // Reset items back to all of the items

    // set val to the value of the searchbar
    const val = ev.target.value;

    this.sortFans();

    // if the value is an empty string don't filter the items
    if (val && val.trim() != "") {
      console.log("this.groups$ " + JSON.stringify(this.groups$));
      for (var i = 0; i < this.groups$.length; i++) {
        this.groups$[i] = this.groups$[i].filter((item: any) => {
          console.log("item to search " + JSON.stringify(item));

          return item["name"].toLowerCase().indexOf(val.toLowerCase()) > -1;
        });
      }
      console.log("this.groups$ filtrado " + JSON.stringify(this.groups$));
      console.log("Titels " + JSON.stringify(this.titles$));
    }
    var arrayGroup: any[] = [];
    var arrayTitle: any[] = [];

    for (var z = 0; z < this.groups$.length; z++) {
      if (this.groups$[z].length != 0) {
        arrayGroup.push(this.groups$[z]);
        arrayTitle.push(this.titles$[z]);
      }
    }
    this.groups$ = arrayGroup;
    this.titles$ = arrayTitle;
  }

  getFansFirebase() {
    var LOADING_FANS = this.translate.instant("LOADING_FANS");
    this.utils.loading(LOADING_FANS);

    this.users$ = [];
    var database = firebase.database().ref("users");
    database.once("value").then(snapshot => {
      var listIdolsFirebase = snapshot.val();
      var keys = Object.keys(listIdolsFirebase);
      for (var x = 0; x < keys.length; x++) {
        var person = listIdolsFirebase[keys[x]];
        person.displayName =
          person.displayName.charAt(0).toUpperCase() +
          person.displayName.slice(1);
        this.users$.push({
          name: person.displayName,
          displayName: person.displayName,
          address: person.address,
          photoURL: person.photoURL
        });
      }
      this.utils.loadingDismiss();
      console.log(" ListFans ", this.users$);
      this.getNameWithoutAccents();
      this.sortFans();
    });
  }

  getNameWithoutAccents() {
    for (var x = 0; x < this.users$.length; x++) {
      this.users$[x].name = this.deleteAccents(
        this.users$[x].name.toLowerCase()
      );
      console.log("fans no accents ", this.users$[x]);
    }
  }

  deleteAccents(cadena) {
    var chars = {
      á: "a",
      é: "e",
      í: "i",
      ó: "o",
      ú: "u",
      à: "a",
      è: "e",
      ì: "i",
      ò: "o",
      ù: "u",
      ñ: "n",
      Á: "A",
      É: "E",
      Í: "I",
      Ó: "O",
      Ú: "U",
      À: "A",
      È: "E",
      Ì: "I",
      Ò: "O",
      Ù: "U",
      Ñ: "N"
    };
    var expr = /[áàéèíìóòúùñ]/gi;
    var res = cadena.replace(expr, function(e) {
      return chars[e];
    });
    return res;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ranking/ranking.ts